import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getAllAttachmentsByItem } from './ItemService';
import { getFile } from '../Attachments/AttachmentService';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Container from 'components/Container';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const ItemAttachmentList = ({ itemId }): JSX.Element => {
  const [attachments, setAttachments] = useState<any[]>([]);
  const [filePreviews, setFilePreviews] = useState({});

  const [loading, setLoading] = useState(false);
  const { itemid } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    listItemAttachments();

    return () => {};
  }, [itemId]);

  function listItemAttachments() {
    setLoading(true);
    getAllAttachmentsByItem(itemid)
      .then((response) => {
        setAttachments(response.data);
        loadFilePreviews(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function loadFilePreviews(attachments) {
    const previews = {};
    attachments.forEach((attachment) => {
      if (attachment.contentType === 'application/pdf') {
        // If the attachment is a PDF, use the PDF icon image
        //previews[attachment.filename] = pdfIcon;
      } else {
        // If it's not a PDF, fetch the thumbnail as before
        getFile(attachment.filename)
          .then((response) => {
            previews[attachment.filename] = URL.createObjectURL(
              new Blob([response.data]),
            );
            setFilePreviews({ ...previews });
          })
          .catch((error) => {
            console.error('Error fetching file:', error);
            notify(extractErrorMessage(error));
          });
      }
    });
  }

  function selectAttachment(attachmentid) {
    console.log(attachmentid);
    navigate(`/manager/dashboard/attachment/${attachmentid}`);
  }

  return (
    <Container>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={4}
      >
        <Typography variant="h4">Attachments</Typography>
      </Box>
      {loading && <p>Loading...</p>}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} aria-label="simple table">
          <TableHead sx={{ bgcolor: 'alternate.main' }}>
            <TableRow>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  ID
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Thumbnail
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Name
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  File Name
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Content Type
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Size
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {attachments.map((item, i) => (
              <TableRow
                key={i}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                onClick={() => selectAttachment(item.id)}
              >
                <TableCell component="th" scope="row">
                  <ListItem sx={{ p: 0, m: 0 }}>
                    <ListItemText primary={item.id} secondary={item.id} />
                  </ListItem>
                </TableCell>
                <TableCell component="th" scope="row">
                  {filePreviews[item.filename] && (
                    <img
                      src={filePreviews[item.filename]}
                      alt="Thumbnail"
                      style={{ width: 50 }}
                    />
                  )}
                </TableCell>
                <TableCell>
                  <Typography>{item.name}</Typography>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography>{item.filename}</Typography>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.filename}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography>{item.contentType}</Typography>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.contentType}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography>{item.size}</Typography>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.size}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default ItemAttachmentList;
